import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import StyledDrawer from "@iscr/views/NUI/StyledDrawer";
import { Button, Checkbox } from "semantic-ui-react";
import { useState } from "react";
// import { ManuallyAddGP } from "./add_gp/ManuallyAddGP";
import { SearchGP } from "./add_gp/SearchGP";
import { ADD_GP_DISPLAY_TYPES } from "./consts";
export const GPSearchDrawer = ({ open, selectedGP: externalSelectedGP, title, onChange, onCancel, showSaveCheckbox = true, }) => {
    const [selectedGP, setSelectedGP] = useState(null);
    const [isGPSaved, setIsGPSaved] = useState(false);
    const onSave = () => {
        // if (selectedGP && displayType === ADD_GP_DISPLAY_TYPES.MANUAL && !validateManuallyAddedGP(selectedGP)) {
        // 	return;
        // }
        const gpToSave = selectedGP ? Object.assign(Object.assign({}, selectedGP), { update_profile: isGPSaved }) : null;
        onChange(gpToSave);
    };
    const onCancelClicked = () => {
        setSelectedGP(null);
        setIsGPSaved(false);
        onCancel();
    };
    const onGPSelected = (gp) => {
        setIsGPSaved(false);
        setSelectedGP(gp);
    };
    // const onGPManuallyAdded = (gp: Partial<GPPractitioner>) => {
    // 	setSelectedGP(gp as GPPractitioner);
    // };
    const [displayType, setDisplayType] = useState(ADD_GP_DISPLAY_TYPES.SEARCH);
    // const changeDisplayType = (type: string) => {
    // 	setIsGPSaved(false);
    // 	setSelectedGP(null);
    // 	setDisplayType(type);
    // };
    const toggleSaveGP = (value) => {
        setIsGPSaved(value);
    };
    // const [errors, setErrors] = useState<ManualGPFormErrors>({});
    // const validateManuallyAddedGP = ({ email, name }: { email: string; name: string }): boolean => {
    // 	const validationErrors: ManualGPFormErrors = {};
    // 	if (!email) validationErrors.email = "Enter your doctor's email address.";
    // 	else if (!email_regex.test(email)) validationErrors.email = "Must be a valid email address.";
    // 	if (!name) validationErrors.name = "Enter your doctor's name.";
    // 	if (validationErrors.name || validationErrors.email) {
    // 		setErrors(validationErrors);
    // 		return false;
    // 	}
    // 	setErrors({});
    // 	return true;
    // };
    return (_jsx(StyledDrawer, { isOpen: open, drawerStyle: "blue", description: "", onClose: onCancel, title: title, content: _jsxs("div", { className: "form ui", children: [_jsx(SearchGP, { selectedGP: selectedGP, setSelectedGP: onGPSelected, isGPSaved: isGPSaved, toggleSaveGP: toggleSaveGP }), selectedGP && showSaveCheckbox && (_jsx("div", { className: "border-solid border-2 rounded-lg p-4 ", children: _jsx(Checkbox, { className: " [&>input]:p-0 !p-0 [&>label]:!leading-[22px] [&>label]:!text-gray-500 [&>label]:!mb-0", label: `Save my doctor details`, size: "massive", checked: isGPSaved ? true : false, onChange: (_e, data) => toggleSaveGP(data.checked) }) })), displayType === ADD_GP_DISPLAY_TYPES.MANUAL && (_jsx("div", { className: "pt-2", children: _jsx(Button, { size: "small", fluid: true, onClick: () => setDisplayType(ADD_GP_DISPLAY_TYPES.SEARCH), children: "Search for GP" }) }))] }), footer: _jsxs("div", { className: "flex flex-row space-x-3 items-stretch", children: [_jsx(Button, { type: "button", fluid: true, secondary: true, onClick: onCancelClicked, children: "Cancel" }), _jsx(Button, { type: "button", fluid: true, primary: true, disabled: !selectedGP || selectedGP.recipientId === (externalSelectedGP === null || externalSelectedGP === void 0 ? void 0 : externalSelectedGP.recipientId), onClick: onSave, children: "Save" })] }) }));
};
